import { _ as __decorate } from '../../tslib.es6-M1zqH4el.js';
import { LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';

let Img = class Img extends LitElement {
    constructor() {
        super(...arguments);
        this.ariaHidden = 'true';
        this.aspectRatio = 'inherit';
        this.objectFit = 'fill';
        this.objectPosition = '50% 50%';
    }
    render() {
        return html `
      <style>
        :host {
          --diamond-img-aspect-ratio: ${this.aspectRatio};
          --diamond-img-object-fit: ${this.objectFit};
          --diamond-img-object-position: ${this.objectPosition};
        }
      </style>
      <slot></slot>
    `;
    }
};
__decorate([
    property({ reflect: true, attribute: 'aria-hidden' })
], Img.prototype, "ariaHidden", void 0);
__decorate([
    property({ reflect: true })
], Img.prototype, "block", void 0);
__decorate([
    property({ reflect: true })
], Img.prototype, "responsive", void 0);
__decorate([
    property({ reflect: true, attribute: 'aspect-ratio' })
], Img.prototype, "aspectRatio", void 0);
__decorate([
    property({ reflect: true })
], Img.prototype, "radius", void 0);
__decorate([
    property({ reflect: true, attribute: 'object-fit' })
], Img.prototype, "objectFit", void 0);
__decorate([
    property({ reflect: true, attribute: 'object-position' })
], Img.prototype, "objectPosition", void 0);
Img = __decorate([
    customElement('diamond-img')
], Img);

export { Img };
